// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"4a5b865b","234":"b3a308f1","248":"128593e5","547":"c0a598b7","777":"753c666a","845":"b86db461"}[chunkId] + ".chunk.js";
};